import React, { FC, Suspense, lazy, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import Route from './Route'
import RouteContext from './RouteContext'
import Loading from '../components/system/Loading'

import withFullRoute from '../hooks/withFullRoute'
import LayoutWeb from '../pages/LayoutWeb'
import NotFound from '../pages/NotFound'

import { NewsletterProvider } from '../contexts/Newsletter'
import { EthProvider } from '../contexts/Eth'
import { LayoutProvider } from '../contexts/Layout'
import { BowieImageProvider } from '../contexts/BowieImage'

import Home from '../pages/Home'
import Impressum from '../pages/Impressum'

const Bowie = lazy(() => import(/* webpackChunkName: "bowie" */ '../pages/bowie/Home'))
const BowiePDF = lazy(() => import(/* webpackChunkName: "bowie" */ '../pages/bowie/PDF'))
const GravenLayout = lazy(() => import(/* webpackChunkName: "graven" */ '../pages/graven/Layout'))
const GravenHome = lazy(() => import(/* webpackChunkName: "graven" */ '../pages/graven/Home'))
const GravenImage = lazy(() => import(/* webpackChunkName: "graven" */ '../pages/graven/Image'))
const GodpixelHome = lazy(() => import(/* webpackChunkName: "godpixel" */ '../pages/godpixel/Home'))
const GodpixelPDF = lazy(() => import(/* webpackChunkName: "godpixel" */ '../pages/godpixel/PDF'))
const ThreeTensHome = lazy(() => import(/* webpackChunkName: "threetens" */ '../pages/threetens/Home'))
const ThreeTensGallery = lazy(() => import(/* webpackChunkName: "threetens" */ '../pages/threetens/Gallery'))
const ThreeTensToken = lazy(() => import(/* webpackChunkName: "threetens" */ '../pages/threetens/Token'))

const Router: FC = ({
  children,
}) => {
  const route = withFullRoute()
  
  if(!route) {
    return (
      <Loading />
    )
  }

  const content = (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{ route.title || 'panNFT' }</title>
      </Helmet>
      <Route segment="notfound" exact>
        <NotFound />
      </Route>
      <Route segment="home" exact>
        <Home />
      </Route>
      <Route segment="impressum" exact>
        <Impressum />
      </Route>
      <Route segment="bowie" exact>
        <Suspense fallback={<div>Loading...</div>}>
          <BowieImageProvider>
            <Bowie />
          </BowieImageProvider>
        </Suspense>
      </Route>
      <Route segment="bowie_pdf" exact>
        <Suspense fallback={<div>Loading...</div>}>
          <BowiePDF />
        </Suspense>
      </Route>
      <Route segment="threetens_home" exact>
        <Suspense fallback={<div>Loading...</div>}>
          <ThreeTensHome />
        </Suspense>
      </Route>
      <Route segment="threetens_gallery" exact>
        <Suspense fallback={<div>Loading...</div>}>
          <ThreeTensGallery />
        </Suspense>
      </Route>
      <Route segment="threetens_token" exact>
        <Suspense fallback={<div>Loading...</div>}>
          <ThreeTensToken />
        </Suspense>
      </Route>
      <Route segment="godpixel_home" exact>
        <Suspense fallback={<div>Loading...</div>}>
          <GodpixelHome />
        </Suspense>
      </Route>
      <Route segment="godpixel_pdf" exact>
        <Suspense fallback={<div>Loading...</div>}>
          <GodpixelPDF />
        </Suspense>
      </Route>
      <Route segment="graven_home" exact>
        <Suspense fallback={<div>Loading...</div>}>
          <GravenHome />
        </Suspense>
      </Route>
      <Route segment="graven_image" exact>
        <Suspense fallback={<div>Loading...</div>}>
          <GravenLayout>
            <GravenImage />
          </GravenLayout>
        </Suspense>
      </Route>
      {
        children
      }
    </>
  )

  let contentWithLayout = content

  if(route.layout == 'web') contentWithLayout = (
    <NewsletterProvider>
      <LayoutWeb>
        { content }
      </LayoutWeb>
    </NewsletterProvider> 
  )

  // BowieProvider is given here because
  return (
    <RouteContext.Provider value={ route.name }>
      <LayoutProvider>
        <EthProvider>
          { contentWithLayout }
        </EthProvider>
      </LayoutProvider>
    </RouteContext.Provider>
  )
}

export default Router